import { EDR_SOLUTION_ID } from 'src/mindtime/constants/securitySolutions';
import { useSubscriptionModulePermissions } from './useSubscriptionPermissionAccess';

export const EDR_GLOBAL_FILTERS_MODULE_ID = 'global-filters' as const;

/** Subscription access for shared EDR toolbar filters (search, date, org, endpoint). */
export const useEdrGlobalFiltersAccess = () => {
  const { can, canModule, permissionsResolved } = useSubscriptionModulePermissions(
    EDR_SOLUTION_ID,
    EDR_GLOBAL_FILTERS_MODULE_ID,
  );

  return {
    canGlobalFilters: canModule,
    canDateRange: can('dateRange'),
    canOrganization: can('organization'),
    canSearch: can('search'),
    canEndpoint: can('endpoint'),
    permissionsResolved,
  };
};
